import React from 'react'
import './scss/referance.css'
import { SectionHeader } from '../../styledcomponents/SectionHeader/SectionHeader'
import  Refcard from '../../styledcomponents/Refcard/index'

import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';



const Referance = (props) =>{
    const qoute1 = "Dedicated learner, very hardwoking and talented. He has really good technical skills and thinks really critical before implementing his work."
    const qoute2 = "I have worked with him on some few projects. His work always comes out very clean and effective. He has immense potential"

    return  (

        <div className="referance"  id = "referance">
            <div className="referance__container">
                
                <SectionHeader>Reference</SectionHeader>
                
                <div className="referance__content">
                    <div className="referance__left">
                        <ScrollAnimation  animateIn="left_ref"  animateOnce = {true}  duration = {0.7}>
                        <Refcard
                        qoute = {qoute1}
                        imageName = "yaya"
                        name = "Umar Zakari"

                         />
                         </ScrollAnimation>
                    </div> 
                    <div className="referance__right">
                        <ScrollAnimation  animateIn="right_ref"   animateOnce = {true}  duration = {0.7}>

                        <Refcard
                        qoute = {qoute2}
                        imageName = "laham"
                        name = "Hamisu Lawal"


                        />
                        </ScrollAnimation>


                    </div>
                </div>

            </div>
        </div>

    )
}

export default Referance